import * as React from 'react';

import './ECheckPaymentDetailsTable.scss';
import ECheckPaymentDetailsRow from './ECheckPaymentDetailsRow/ECheckPaymentDetailsRow';

interface IECheckPaymentDetailsTableProps {
  invoices: any[];
  customerCode: string;
}

class ECheckPaymentDetailsTable extends React.Component<
  IECheckPaymentDetailsTableProps,
  any
> {
  public render() {
    return (
      <div className="rp-echeck-payment-details-table">
        <div className="rp-echeck-details-container">
          <div className="rp-echeck-p-details-header col-2">
            <h4>Invoice</h4>
          </div>
          <div className="rp-echeck-p-details-header col-2">
            <h4>Invoice Date</h4>
          </div>
          <div className="rp-echeck-p-details-header col-2">
            <h4>Customer Po</h4>
          </div>
          <div className="rp-echeck-p-details-header col-2">
            <h4>Total Amt</h4>
          </div>
          <div className="rp-echeck-p-details-header col-2">
            <h4>Payment Amt</h4>
          </div>
          <div className="rp-echeck-p-details-header col-2">
            <h4>Reason for remaining amount</h4>
          </div>
        </div>
        <div className="rp-echeck-p-details-data-container">
          {this.props.invoices.map(invoice => (
            <ECheckPaymentDetailsRow
              key={invoice.invoiceNumber}
              invoice={invoice}
              customerCode={this.props.customerCode}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default ECheckPaymentDetailsTable;
